import { initSyncManager } from './services/syncManager';
import { initDb } from './services/offlineDb';
import logger from './utils/logger';

export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;

  initDb();

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((reg) => {
        logger.log('Service worker registered:', reg.scope);
        initSyncManager(reg);
      })
      .catch((err) => {
        logger.error('Service worker registration failed:', err);
        initSyncManager();
      });
  });
}

export async function unregisterServiceWorker(): Promise<void> {
  if (!('serviceWorker' in navigator)) return;
  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((r) => r.unregister()));
}
